<template>
<div class="house-info">

</div>
</template>

<script>
export default {
  name: "HouseInfo",
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/components/HouseInfo.vue